<dx-popup
    title="Customer Rate"
    [width]="600"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    @if (rate) {
        <dx-form [formData]="rate">
            <dxi-form-item [label]="{ text: 'Type' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="rate.rateTypeId"
                        [items]="rateTypes"
                        valueExpr="id"
                        displayExpr="name"
                        (onValueChanged)="rateTypeChanged($event)"
                    ></dx-select-box>
                </div>
            </dxi-form-item>
            @if (showDumpsterSelection) {
                <dxi-form-item [label]="{ text: 'Size' }">
                    <div *dxTemplate>
                        <dx-select-box [(value)]="rate.dumpsterId" [items]="dumpsters" valueExpr="id" displayExpr="size"></dx-select-box>
                    </div>
                </dxi-form-item>
            }
            @if (rate.rateTypeId !== 4) {
                <dxi-form-item [label]="{ text: 'Range' }">
                    <div *dxTemplate>
                        <dx-radio-group [dataSource]="ranges" [(value)]="rate.range" layout="horizontal"> </dx-radio-group>
                    </div>
                </dxi-form-item>
            }
            @if (rate.rateTypeId === 4) {
                <dxi-form-item [label]="{ text: 'Zones' }">
                    <div *dxTemplate>
                        <dx-radio-group [dataSource]="zones" [(value)]="rate.zone" layout="horizontal"> </dx-radio-group>
                    </div>
                </dxi-form-item>
            }
            <dxi-form-item
                dataField="rate"
                editorType="dxNumberBox"
                [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
            ></dxi-form-item>
            @if (rate.rateTypeId === 2 || rate.rateTypeId === 4) {
                <dxi-form-item
                    dataField="pricePerTon"
                    [label]="{ text: 'Price/Ton' }"
                    editorType="dxNumberBox"
                    [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
                ></dxi-form-item>
            }
            <dxi-form-item dataField="weightLimit" editorType="dxNumberBox"></dxi-form-item>
            @if (rate.rateTypeId === 2) {
                <dxi-form-item dataField="baseMileage" editorType="dxNumberBox"></dxi-form-item>
            }
            @if (rate.rateTypeId === 2) {
                <dxi-form-item dataField="mileageOffset" editorType="dxNumberBox"></dxi-form-item>
            }
            @if (rate.rateTypeId === 2) {
                <dxi-form-item
                    dataField="mileageOffsetRate"
                    editorType="dxNumberBox"
                    [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
                ></dxi-form-item>
            }
            <dxi-form-item [label]="{ text: 'Rate Notes' }">
                <div *dxTemplate>
                    <dx-text-area [(value)]="rate.notes" [height]="'50px'"></dx-text-area>
                </div>
            </dxi-form-item>
        </dx-form>
    }
</dx-popup>
